module.exports = __webpack_public_path__ + "img/p5.2d621e91.png";